import tokenApiService from '@/request/token/token.api.service';
import { IHotToken } from '@/request/token/token.response.interface';
import { useBoomWallet } from '@boomeme/wallet-sdk';
import { useEffect, useState } from 'react';

export const useSearchHotToken = (isOpen: boolean) => {
  const { chain } = useBoomWallet();
  const [tokenList, setTokenList] = useState<IHotToken[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await tokenApiService.getTokenHotList();
      if (res.code === 0) {
        setTokenList(res.data.slice(0, 10));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    isOpen && fetchData();
  }, [isOpen, chain]);

  return {
    tokenList,
    isLoading,
  };
};
